/* dtf-transfers: hide the "VIVID AF" promo video (<video-popup>) once the
   customer has uploaded artwork. Pre-upload it shows; post-upload it's clutter,
   so Justin asked to remove it after upload. Post-upload signal = ANY of:
   body.image-uploaded, body.activeImgPreviewer (design-previewer-active class),
   or an <uploaded-files-block> in the DOM (the multi-upload modal's per-design
   block). image-uploaded reads false in some flows — notably the LOGGED-OUT
   upload (incognito) never sets it, yet the design previewer still activates, so
   activeImgPreviewer is what catches that case (verified: absent pre-upload,
   set post-upload regardless of login); uploaded-files-block covers the
   multi-upload modal. Re-shows the video if the upload is reset.
   Deploy-around (the video markup lives in the over-limit main-product section);
   loaded only on /products/dtf-transfers via a gated tag in layout/theme.liquid. */
(function () {
  function uploaded() {
    return document.body.classList.contains('image-uploaded') ||
           document.body.classList.contains('activeImgPreviewer') ||
           !!document.querySelector('uploaded-files-block');
  }
  function apply() {
    /* querySelectorAll (not querySelector) so every <video-popup> instance is
       covered, and setProperty(...,'important') (not plain style.display='none'):
       the product gallery re-renders the popup slide around the upload-state swap
       and a theme/gallery rule re-shows it, which beat the old non-important
       inline 'none' — so the popup came back VISIBLE after upload. !important
       makes the hide stick; removeProperty restores it on reset. */
    var vps = document.querySelectorAll('video-popup');
    var up = uploaded();
    for (var i = 0; i < vps.length; i++) {
      if (up) vps[i].style.setProperty('display', 'none', 'important');
      else vps[i].style.removeProperty('display');
    }
  }
  function init() {
    apply();
    /* The upload state changes dynamically (class toggle + the modal's
       uploaded-files-block being added/removed); re-apply on any of that,
       debounced via setTimeout — NOT requestAnimationFrame: rAF gets starved on
       the heavy DTF PDP, which left the debounce flag stuck so apply never ran. */
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; apply(); }, 120);
    }).observe(document.documentElement, {
      attributes: true, attributeFilter: ['class'], childList: true, subtree: true
    });
    /* The gallery re-creates the <video-popup> slide around the upload-state
       swap, which the observer's debounce can miss (the popup returned visible
       with its inline display unset). Re-apply on a light interval too — the
       proven pattern on this heavy PDP (the reward-chip mover uses the same). */
    setInterval(apply, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
